import colors from '@constants/colors';

import type { TextProps } from '@components/Text/type';

export const FORM_ITEM_LABEL_STYLE: TextProps = {
  size: 12,
  color: colors.GRAY_ORIGIN_1,
};
